import { ONEServiceType } from "../utils/objects";

export class ClientTreeNode {

    constructor(nodeID, resID, path, type) {

        if (nodeID && typeof nodeID != "String" && typeof nodeID != "undefined" && typeof nodeID != "string") {
            var otherNode = nodeID;
            this.nodeID = otherNode.nodeID;
            this.resID = otherNode.resID;
            this.path = otherNode.path;
            this.type = otherNode.type; // FileFolderEntityType: ...\iperius-enterprise-agent\IperiusEWP\BackupSources\FileFolder\Core\Utils\Enums.cs

            this.nParts = otherNode.nParts;
            this.children = otherNode.children;
            this.visible = otherNode.visible;

            return this;
        }

        this.nodeID = nodeID;
        this.resID = resID;
        this.path = path;
        this.type = type; // FileFolderEntityType: ...\iperius-enterprise-agent\IperiusEWP\BackupSources\FileFolder\Core\Utils\Enums.cs

        var slash = path.getSeparator();

        this.nParts = path.endsWith(":/") ? 1 : path.split(slash).length;
        this.children = type.isFile() ? null : [];
        this.visible = true;

        return this;
    }


}

export const FileSystemSidebarConfig = {
    get: function (type, includeFiles, limit, client = null, rootPath = null, tree = null, isRootSelectable = true) {
        return {
            type: type,
            includeFiles: includeFiles,
            limit: limit,
            client: client,
            rootPath: rootPath,
            tree: tree,
            isRootSelectable: isRootSelectable
        }
    },
    getForSource: function (type, client, rootPath) {
        return this.get(type, true, 0, client, rootPath, null, [ONEServiceType.Network, ONEServiceType.FTP].includes(type));
    },

    getForDestination: function (type, client = null, rootPath = null, isRootSelectable = true) {
        return this.get(
            type, false, 1, client, rootPath, null, isRootSelectable
        );
    },
    getForFileFolderDestination: function () {
        return this.get(ONEServiceType.FileFolder, false, 1, null, null, null, false);
    },
    getForSelectCopyPath: function (type, client, rootPath) {
        return this.get(type, false, 1, client, rootPath, null, false);
    }
}

